import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppCostCenters } from '../models/appCostCenter.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { LivesSessionHelper } from '../helper/livesSessionHelper';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable()
export class AppCostCentersService extends HttpClientBaseService implements IServiceBase<AppCostCenters> {

    constructor(
        _http: HttpClient,
        private _livesSession: LivesSessionHelper,
    ) {
        super(_http, '/costcenters/', '', false);

    }
    getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppCostCenters>> {
        throw new Error('Method not implemented.');
    }

    getAllModels(): Observable<AppCostCenters[]> {
        const environmentID = this._livesSession.EnvironmentId;
        const userID = this._livesSession.AspNetUserId;
        const url = `${AppConfig.settings.apiServerPE.apiUrl}innuva/costcenters?environment=${environmentID}&hostelUserId=${userID}&hostelUserEnabled=true`;
        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });


        // Realizar la petición PATCH y devolver el resultado como un Observable
        return this.http.get<AppCostCenters[]>(url, { headers: headers });

    }

    getModel(id: any): Observable<AppCostCenters> {
        throw new Error('Method not implemented.');
    }




}
